module.exports = __webpack_public_path__ + "img/13-5.d47624c2.jpg";